// Runtime safety for restricted/older JS environments
const objectApiNames = ['getOwnPropertyNames', 'getOwnPropertyDescriptor', 'defineProperty']
const missingBeforePolyfill = objectApiNames.filter((name) => typeof Object[name] !== 'function')

if (typeof Object.getOwnPropertyNames !== 'function') {
    Object.getOwnPropertyNames = function getOwnPropertyNamesFallback(obj) {
        const out = []
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) out.push(key)
        }
        return out
    }
}

if (typeof Object.getOwnPropertyDescriptor !== 'function') {
    Object.getOwnPropertyDescriptor = function getOwnPropertyDescriptorFallback(obj, prop) {
        if (!Object.prototype.hasOwnProperty.call(obj, prop)) return undefined
        return {
            configurable: true,
            enumerable: true,
            writable: true,
            value: obj[prop],
        }
    }
}

if (typeof Object.defineProperty !== 'function') {
    Object.defineProperty = function definePropertyFallback(obj, prop, descriptor) {
        // Best-effort fallback; sufficient for many helper patterns
        if (descriptor && 'value' in descriptor) obj[prop] = descriptor.value
        return obj
    }
}

if (missingBeforePolyfill.length > 0 && typeof console !== 'undefined' && typeof console.warn === 'function') {
    console.warn('[polyfills] Missing Object APIs at startup:', missingBeforePolyfill.join(', '))
}
